import './homepageBanner.css'
import Image1 from '../../pages/projects/assets/northwoods/IMG_2387.jpg'


export default function homepageBanner() {
    return (
        <div className='imgWrapper'>
            <div className='imageRotation'>
                <img src={Image1} alt='placeholder'>
                
                </img>
            </div>
        </div>
    );

};
